import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { Shield, Eye, Lock, User } from 'lucide-react'

import Section from '../components/ui/Section'
import GlassCard from '../components/ui/GlassCard'

const Privacy = () => {
  const { t } = useTranslation()

  const sections = [
    {
      icon: Eye,
      title: "Collecte d'informations",
      content: "Nous collectons uniquement les informations nécessaires pour vous fournir nos services, notamment lors de la prise de rendez-vous ou de contact. Ces informations incluent votre nom, adresse email et numéro de téléphone."
    },
    {
      icon: Lock,
      title: "Protection des données",
      content: "Toutes vos données personnelles sont stockées de manière sécurisée et ne sont jamais partagées avec des tiers sans votre consentement explicite. Nous utilisons des mesures de sécurité appropriées pour protéger vos informations."
    },
    {
      icon: User,
      title: "Vos droits",
      content: "Conformément au RGPD, vous avez le droit d'accéder à vos données, de les rectifier, de les supprimer ou de limiter leur traitement. Vous pouvez exercer ces droits en nous contactant directement."
    },
    {
      icon: Shield,
      title: "Cookies et tracking",
      content: "Notre site utilise des cookies essentiels pour son fonctionnement. Nous n'utilisons pas de cookies de tracking pour des publicités. Vous pouvez modifier vos préférences de cookies à tout moment."
    }
  ]

  return (
    <div className="min-h-screen pt-32 pb-20">
      <Section
        title="Politique de Confidentialité"
        subtitle="Protection de vos données personnelles et respect de votre vie privée"
      >
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="max-w-4xl mx-auto space-y-8"
        >
          {/* Introduction */}
          <GlassCard className="p-8">
            <div className="text-center mb-8">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-primary-100 rounded-full mb-4">
                <Shield className="w-8 h-8 text-primary-600" />
              </div>
              <h2 className="text-2xl font-bold text-black mb-4">
                Notre Engagement envers votre Confidentialité
              </h2>
              <p className="text-gray-600 leading-relaxed">
                Résidences Masséna Inc. s'engage à protéger votre vie privée et vos données personnelles. 
                Cette politique explique comment nous collectons, utilisons et protégeons vos informations.
              </p>
            </div>
          </GlassCard>

          {/* Sections principales */}
          {sections.map((section, index) => {
            const Icon = section.icon
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
              >
                <GlassCard className="p-6">
                  <div className="flex items-start space-x-4">
                    <div className="flex-shrink-0">
                      <div className="w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center">
                        <Icon className="w-6 h-6 text-primary-600" />
                      </div>
                    </div>
                    <div className="flex-1">
                      <h3 className="text-xl font-bold text-black mb-3">
                        {section.title}
                      </h3>
                      <p className="text-gray-600 leading-relaxed">
                        {section.content}
                      </p>
                    </div>
                  </div>
                </GlassCard>
              </motion.div>
            )
          })}

          {/* Contact */}
          <GlassCard className="p-8 bg-gradient-to-br from-primary-50 to-blue-50">
            <div className="text-center">
              <h3 className="text-xl font-bold text-black mb-4">
                Questions sur votre confidentialité ?
              </h3>
              <p className="text-gray-600 mb-6">
                Si vous avez des questions concernant cette politique de confidentialité ou vos données personnelles, 
                n'hésitez pas à nous contacter.
              </p>
              <div className="space-y-2 text-sm text-gray-700">
                <p><strong>Email :</strong> admin@residencemassena.com</p>
                <p><strong>Téléphone :</strong> (450) 628-2696</p>
                <p><strong>Adresse :</strong> 444 Avenue Yvon-Berger, Laval, QC H7L 2C2</p>
              </div>
            </div>
          </GlassCard>

          {/* Dernière mise à jour */}
          <div className="text-center text-sm text-gray-500">
            <p>Dernière mise à jour : {new Date().toLocaleDateString('fr-CA')}</p>
          </div>
        </motion.div>
      </Section>
    </div>
  )
}

export default Privacy


